// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminDamagesDepreciations,
  apiPatchAdminDamagesDepreciations
} from '@/services/API/admin'

export default {
  name: 'depreciations',
  data: function () {
    return {
      depreciation: {
        repTypeCode: null,
        description: null,
        years: null,
        depreciationPerc: null
      }
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminDamagesDepreciations(this.currentPage, this.filterWarrantyId, this.filterSubwarrantyId)
        .then(depreciations => {
          this.table = depreciations.results
          this.totalPages = depreciations.total_pages || 0
        })
    },
    handleEdit: function (repTypeCode, description, years, depreciationPerc) {
      this.depreciation = { repTypeCode, description, years, depreciationPerc }
      this.$refs.adminEditModal.showModal = true
    },
    resetEditValues: function () {
      this.depreciation.repTypeCode = null
      this.depreciation.years = null
      this.depreciation.depreciationPerc = null
    },
    handleSave: function () {
      apiPatchAdminDamagesDepreciations(
        this.depreciation.repTypeCode,
        this.depreciation.description,
        this.depreciation.years,
        this.depreciation.depreciationPerc
      )
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    }
  },
  mounted: function () {
    this.handleSearch()
  }
}
